import { render, staticRenderFns } from "./reserveOrder.vue?vue&type=template&id=0e53752c&scoped=true"
import script from "./reserveOrder.vue?vue&type=script&lang=js"
export * from "./reserveOrder.vue?vue&type=script&lang=js"
import style0 from "./reserveOrder.vue?vue&type=style&index=0&id=0e53752c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53752c",
  null
  
)

export default component.exports